module.exports = __webpack_public_path__ + "static/media/foto3.2c76476d.png";